import { BannersConfigWithDefault } from './configs/game-configs'
import { defaultGameMinWidth, defaultGameMinHeight, GAME_TARGET_ID, bannerTypeArray } from './constants'

// Todo: can be improved by reusing the bannersControl object
const adPlaceholders: HTMLDivElement[] = []

interface BannersControl {
  // Is game tab active or passive?
  isActiveTab: boolean
  horizontal: {
    // Is it being displayed? (screen size might set this to false)
    isShown: boolean
    // The condition that defines it (level, payment, etc)
    isEnabled: boolean
  }
  vertical: {
    isShown: boolean
    isEnabled: boolean
  }
}

export const bannersControl = <BannersControl>{ vertical: {}, horizontal: {} }

export const minWindowWidthHorizontalAd = 728

const setGameIframeSize = (width: string, height: string, marginTop: number) => {
  const gameIFrame = document.querySelector(`#${GAME_TARGET_ID}`) as HTMLIFrameElement

  gameIFrame.style.width = width
  gameIFrame.style.height = height
  gameIFrame.style.marginTop = `${marginTop}px`

  return true
}

const isPixelNotation = (dimension: number | string): dimension is number => typeof dimension === 'number'

const getGameIframeSize = (adSlotSettings: BannersConfigWithDefault['adSlotSettings']) => {
  let higherWidth = 0
  let higherHeight = 0

  for (const adSlotSetting of adSlotSettings) {
    const {
      htmlElements: {
        adPlaceholder: { width, height },
      },
    } = adSlotSetting
    if (isPixelNotation(width) && width > higherWidth) {
      higherWidth = width as number
    }

    if (isPixelNotation(height) && height > higherHeight) {
      higherHeight = height as number
    }
  }

  return {
    width: `calc(100vw - ${higherWidth}px)`,
    height: `calc(100vh - ${higherHeight}px)`,
    bannerWidth: higherWidth,
    bannerHeight: higherHeight,
  }
}

const addBannerDiv = (adSlotSetting: BannersConfigWithDefault['adSlotSettings'][0]) => {
  const { htmlElements } = adSlotSetting
  if (!document.querySelector(`#${htmlElements.adContainer.id}`)) {
    // Creating parent div
    const thisAdPlaceHolder = document.createElement('div')

    thisAdPlaceHolder.setAttribute('id', htmlElements.adPlaceholder.id)
    thisAdPlaceHolder.setAttribute('style', htmlElements.adPlaceholder.style)

    const adDiv = document.createElement('div')
    adDiv.setAttribute('id', htmlElements.adContainer.id)
    adDiv.setAttribute('style', htmlElements.adContainer.style)

    thisAdPlaceHolder.append(adDiv)

    document.body.append(thisAdPlaceHolder)

    adPlaceholders.push(thisAdPlaceHolder)
  }
}

const getGameMinWidth = () => {
  return (
    Number.parseInt((document.querySelector(`#${GAME_TARGET_ID}`) as HTMLIFrameElement).style.minWidth, 10) ||
    defaultGameMinWidth
  )
}

const getGameMinHeight = () => {
  return (
    Number.parseInt((document.querySelector(`#${GAME_TARGET_ID}`) as HTMLIFrameElement).style.minHeight, 10) ||
    defaultGameMinHeight
  )
}

const hideAd = (adBannerTypes: bannerTypeArray) => {
  for (const adBannerType of adBannerTypes) {
    const adPlaceholder = adPlaceholders.find((adPlaceholder) => adPlaceholder.id.includes(adBannerType))
    if (adPlaceholder) {
      adPlaceholder.remove()
      bannersControl[adBannerType].isShown = false
    }
  }
}

const showAd = (adBannerTypes: bannerTypeArray) => {
  for (const adBannerType of adBannerTypes) {
    const adPlaceholder = adPlaceholders.find((adPlaceholder) => adPlaceholder.id.includes(adBannerType))
    if (adPlaceholder) {
      document.body.append(adPlaceholder)
      bannersControl[adBannerType].isShown = true
    }
  }
}

export { setGameIframeSize, getGameIframeSize, addBannerDiv, getGameMinWidth, getGameMinHeight, hideAd, showAd }
